import { FormGroup, FormArray, AbstractControl } from '@angular/forms';

import { ValidationSummary } from '../_models/validation-summary.model';
import { addValidation } from './validation.util';

export const getAllErrors = (form: FormGroup | FormArray) => {
  const errorSummary = Object.keys(form.controls).reduce((acc, key) => {
    const control = form.get(key);
    if (control) {
      let validation: ValidationSummary = { key, control };

      if (control.errors) {
        const { errors } = control;
        validation = { ...validation, errors };
      }

      if (hasChildren(control)) {
        validation = {
          ...validation,
          children: getAllErrors(control as FormGroup | FormArray)
        };
      }
      acc = addValidation(acc, validation);
    }

    return acc;
  }, [] as ValidationSummary[]);

  return errorSummary;

  /**
   * helpers
   */
  function hasChildren(c: AbstractControl) {
    return (c.hasOwnProperty('controls') && c instanceof FormGroup) || c instanceof FormArray;
  }
};
